import { BargainUserInfo } from '../../../../types'

export interface FormData {
  shopId: number | null
  productName: string
  comment: string
  posterName: string
  price: string
}

export const validateForm = (
  formData: FormData,
  bargain_user_info: BargainUserInfo,
  images?: File[]
): { isValid: boolean; error: string | null } => {
  if (!formData.shopId) {
    return { isValid: false, error: 'お店を選択してください' }
  }

  if (!formData.productName.trim()) {
    return { isValid: false, error: '商品名を入力してください' }
  }

  if (formData.productName.length > 50) {
    return { isValid: false, error: '商品名は50文字以内で入力してください' }
  }

  if (!formData.comment.trim() && images?.length === 0) {
    return { isValid: false, error: 'コメントまたは画像を入力してください' }
  }

  if (formData.comment.length > 200) {
    return { isValid: false, error: 'コメントは200文字以内で入力してください' }
  }

  // ユーザー名がない場合は入力が必要
  if (!bargain_user_info.name && !formData.posterName.trim()) {
    return { isValid: false, error: 'ユーザー名を入力してください' }
  }

  if (formData.posterName.length > 10) {
    return { isValid: false, error: 'ニックネームは10文字以内で入力してください' }
  }

  if (images && images.length > 1) {
    return { isValid: false, error: '画像は1枚まで投稿できます' }
  }

  return { isValid: true, error: null }
}
